import { callApi } from "@src/utils/api-client";
import { getFailureTypeForHttpStatus } from "@src/utils/failure-taxonomy";
import ClientLogsService from "./client-logs.service";
import { buildUnfreezeAppointmentConfig } from "./configs";
export const unfreezeAppointment = async (userUuid: string) => {
  try {
    const { data, response } = await callApi(buildUnfreezeAppointmentConfig(userUuid));
    if (!response.ok) {
      ClientLogsService.logError(
        userUuid || "unknown",
        "unfreeze-appointment.service.unfreezeAppointment",
        "Failed to unfreeze user appointment",
        new Error(
          `HTTP ${response.status}: ${response.statusText}${
            (data as { message?: string } | null)?.message
              ? " - " + (data as { message?: string }).message
              : ""
          }`,
        ),
        {
          errorType: getFailureTypeForHttpStatus(response.status),
          dependencyName: "UnfreezeAppointmentAPI",
          functionName: "unfreezeAppointment",
        },
      );
      return {
        error:
          (data as { message?: string } | null)?.message || "Error unfreezing user appointment.",
      };
    }
    if (data === null) {
      throw new Error("Invalid JSON response");
    }
    return data;
  } catch (err: any) {
    ClientLogsService.logError(
      userUuid || "unknown",
      "unfreeze-appointment.service.unfreezeAppointment",
      "Error unfreezing user appointment",
      err instanceof Error ? err : new Error("Unknown error"),
      {
        errorType: "DependencyFailure",
        dependencyName: "UnfreezeAppointmentAPI",
        functionName: "unfreezeAppointment",
      },
    );
    throw new Error(`Failed to unfreeze appointment: ${err.message}`);
  }
};
